export default {
    meta: {
        title: '鱼你在一起-创建沟通纪要',
        url: '/fishtogether/tasklist',
        urlName: '鱼你拓店任务'
    }
};
